import { API_URLS } from 'src/constants/apis';
import { httpClient } from 'src/utils/httpClient/httpClient';

export const deleteVideo = async (
  jwt: string,
  id: string,
): Promise<Response> => {
  const res = await httpClient(`${API_URLS.deleteVideo}${id}`, 'DELETE', {
    Authorization: `Bearer ${jwt}`,
  });

  return res;
};
